import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IPaginate } from '@projects/shared/src/app/modules/pagination/paginate.pipe';
import { ParticipantChannelType } from '../../features/chat/interfaces/transcript/ConversationAndOfflineMessagesResponse';
import { AuthenticationService } from '@app/core';
import { ToastService } from '../../services/toast/toast.service';
import { TelephonyStateService } from '../../providers/telephony/telephony.state.service';
import { AgentStatusService } from '../../services/agentstatus.service';
import { Constants } from '@app/constants';
import { AppConfigurationService } from '../../services/app.configuration.service';
@Component({
  selector: 'app-recent-activity-table',
  templateUrl: './recent-activity-table.component.html',
  styleUrls: ['./recent-activity-table.component.scss'],
})
export class RecentactivityTableComponent implements OnInit {
  ParticipantChannelType = ParticipantChannelType;
  public pagingConfig: IPaginate = {
    id: 'chats',
    itemsPerPage: 15,
    currentPage: 1,
  };
  @Input() tag: string = '';
  @Input() columns: any = [];
  @Input() rows: any = [];
  @Input() callEnabled: boolean = true;
  @Input() callIndex: number = -1;
  @Output() onCallClick = new EventEmitter<any>();
  constructor(
    public authService: AuthenticationService,
    private toastService: ToastService,
    private telephonyState: TelephonyStateService,
    private statusService: AgentStatusService,
    private appConfig: AppConfigurationService
  ) {}

  ngOnInit(): void {}

  onSort(e: any) {
  }

  onPageChange(page: number) {
    this.pagingConfig.currentPage = page;
    // this.pagingConfig.currentPage = e.
  }
  onPageSizeChange(pageSize: any) {
    this.pagingConfig.itemsPerPage = pageSize;
  }
  async dialCall(number: string, index: number, tfn: string, campaign: any, ucid: any) {
    //* FOR PK ONLY
    //* TRACK CallBack Count
    let res = await this.authService.fetchTodayCallbacksCount();
    const count = res?.length > 0 ? res[0].count : 0;
    const limit = this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS').Fields['CALL_BACK_CALLS_LIMIT'] ?? 15;

    let isLimitReached: boolean = count === limit;
    if (isLimitReached) {
      this.toastService.warning('Maximum number of Callback reached');
      return;
    }
    //* TRACK OutboundCallResitriction for specific time
    if (this.telephonyState.isOutboundCallRestriction(campaign.tfnCampaignCode)) {
      return;
    }
    if(this.isIbexDialer()) {
      const allowedStatuses = ['Callback', 'ManualCall'];
      if (!allowedStatuses.includes(this.statusService.currentStatus.FriendlyName)) {
        this.toastService.info('Manual Call or Callback status is required to make a call');
        return;
      }
    }
   
    this.rows[index].show = false;
    this.onCallClick.emit({ number, index, tfn, campaign, ucid });
  }


  // TODO: replace it with getNameInitials from helper
  getNameInitials(name: string) {
    const words = name.split(' ');
    let initials = '';

    // Get the first character of each word for the first two words
    initials = words
      .slice(0, 2)
      .map((word) => word[0])
      .join('');

    return initials === '' ? 'FD' : initials;
  }
  toggleCallOption(row: any): void {
    if (row.show) {
      row.show = !row.show;
    } else {
      this.hideAllOptions();
      row.show = !row.show;
    }
  }

  // Optionally, a method to hide all dropdowns
  hideAllOptions(): void {
    this.rows.forEach((row: any) => {
      row.show = false;
    });
  }
  public isIbexDialer() {
    const providerKey = this.authService.getTelephonyProvider();
    return providerKey === 'ibex' ? true : false;
  }
}
